import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { Form, Spinner, ListGroup, Image, Button } from "react-bootstrap";

const getAuthToken = () => localStorage.getItem("authToken");

const SwipeCard = () => {
    const [loading, setLoading] = useState(false);
    const [scannedStudents, setScannedStudents] = useState([
        {
            name: "Waiting for Scan...",
            class: "",
            division: "",
            photo: `blank.png`
        },
    ]);
    const [cardNumber, setCardNumber] = useState("");
    const inputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => setErrorMessage(""), 3000);
            return () => clearTimeout(timer);
        }
    }, [errorMessage]);

    useEffect(() => {
        const handleKeyPress = () => {
            if (document.activeElement !== inputRef.current) {
                inputRef.current.focus();
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return () => document.removeEventListener("keydown", handleKeyPress);
    }, []);

    const markAttendanceByRFID = async () => {
        if (!cardNumber) return;

        setLoading(true);
        setErrorMessage(null);
        const token = getAuthToken();
        if (!token) {
            setErrorMessage("Unauthorized! Please log in.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}swipe-attendance`,
                { card_number: cardNumber },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setScannedStudents((prev) => [
                response.data.student,
                ...prev.filter((s) => s.name !== "Waiting for Scan..."),
            ]);
            
            
        } catch (error) {
            setErrorMessage(error.response?.data?.message || "Error marking attendance.");
        }
        finally {
            setCardNumber("");
        }

        setLoading(false);
    };

    return (
            <div className="container p-3">
    {errorMessage && (
        <div className="alert alert-danger py-1 px-2 text-center small">
            {errorMessage}
        </div>
    )}
    <Form onSubmit={(e) => e.preventDefault()} className="mb-3">
        <Form.Control
            type="text"
            placeholder="Scan RFID Card..."
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && markAttendanceByRFID()}
            ref={inputRef}
            autoFocus
            className="position-absolute"
            style={{ opacity: 0, left: "-9999px"}}
            tabIndex={-1}
        />
    </Form>

    {loading && <Spinner animation="border" className="d-block mx-auto my-2" />}

    <div 
        className="d-flex flex-wrap align-items-start" 
        style={{ 
            columnGap: "15px", 
            maxHeight: "80vh", 
            overflowY: "auto" 
        }}
    >
        {/* First Student as Portrait Card */}
        {scannedStudents.length > 0 && (
            <div 
                className="d-flex flex-column align-items-center p-3 shadow-sm rounded"
                style={{
                    width: "150px",
                    textAlign: "center",
                    background: "#f8f9fa",
                    borderRadius: "10px",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)"
                }}
            >
                <Image
                    src={scannedStudents[0].photo ? 
                        `${appConstants.API_ROOT_URL}uploads/students/${scannedStudents[0].photo}` : 
                        `${appConstants.API_ROOT_URL}uploads/students/blank.png`}
                    roundedCircle
                    width="80"
                    height="80"
                    className="mb-2"
                />
                <strong>{scannedStudents[0].name}</strong>
                <small>{scannedStudents[0].class} {scannedStudents[0].division}</small>
            </div>
        )}

        {/* Remaining Students in Columns */}
        <div className="d-flex flex-wrap" style={{ columnGap: "15px" }}>
            {[...scannedStudents.slice(1)].reduce((columns, student, index) => {
                const screenWidth = window.innerWidth;
                let maxItemsPerColumn = screenWidth < 576 ? Infinity : 8; // No limit on mobile, 8 per column on larger screens
                const columnIndex = Math.floor(index / maxItemsPerColumn);

                if (!columns[columnIndex]) columns[columnIndex] = [];
                columns[columnIndex].push(student);
                return columns;
            }, []).map((column, colIndex) => (
                <div 
                    key={colIndex} 
                    className="d-flex flex-column" 
                    style={{ 
                        minWidth: "200px", 
                        flex: "1 1 auto", 
                        maxWidth: "300px" 
                    }}
                >
                    {column.map((student, index) => (
                        <ListGroup.Item key={index} className="d-flex align-items-center mb-2">
                            <Image
                                src={student.photo ? 
                                    `${appConstants.API_ROOT_URL}uploads/students/${student.photo}` : 
                                    `${appConstants.API_ROOT_URL}uploads/students/blank.png`}
                                roundedCircle
                                width="40"
                                height="40"
                                className="me-2"
                            />
                            <div>
                                <strong>{student.name}</strong>
                                <br />
                                <small>{student.class} {student.division}</small>
                            </div>
                        </ListGroup.Item>
                    ))}
                </div>
            ))}
        </div>
    </div>
</div>

    );
};

export default SwipeCard;
